import { Component, OnChanges, SimpleChanges, inject, input } from '@angular/core';
import { CollectionsService } from '../../collections/collections.service';
import { MediaService, SvgViewboxDirective } from '@exl-ng/mulo-core';
import { I18nService } from '../../core/i18n.service';
import { UrlUtils } from '../../shared/utils/url.utils';
import { Collection } from '../../shared/interfaces/collection.interface';
import { take } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatAnchor } from '@angular/material/button';
import { HorizontallerComponent, HorizontallerItemComponent } from '@exl-ng/mulo-common';
import { CenteredBlockLayoutComponent, FeaturedTileComponent } from '@exl-ng/mulo-views';


@Component({
    selector: 'esp-research-unit-collections',
    templateUrl: './research-unit-collections.component.html',
    styleUrls: ['./research-unit-collections.component.scss'],
    imports: [
        CenteredBlockLayoutComponent,
        HorizontallerComponent,
        HorizontallerItemComponent,
        MatAnchor,
        RouterLink,
        FeaturedTileComponent,
        MatIcon,
        SvgViewboxDirective,
        TranslateModule
    ]
})
export class ResearchUnitCollectionsComponent implements OnChanges {
    private collectionsService = inject(CollectionsService);
    media = inject(MediaService);
    i18nService = inject(I18nService);

    institution = UrlUtils.getParam('institution');
    featuredCollections: Collection[] = [];
    readonly unitCode = input<string>(undefined);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['unitCode'] && changes['unitCode'].currentValue) {
            this.collectionsService
                .getOrganizationCollections(changes['unitCode'].currentValue)
                .pipe(take(1))
                .subscribe((data) => {
                    this.featuredCollections = data;
                });
        }
    }
}
